import React, { useEffect, useState } from "react";
import { ILoyaltyCustomer, ITier } from "redux/reducers/models/loyalty";
import "./loyaltyProgramRewards.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
import Card from "components/card/Card";
import classNames from "classnames";
import { faCircle } from "@fortawesome/pro-solid-svg-icons";

interface IProps {
    tiers: Array<ITier>;
    customer: ILoyaltyCustomer;
}


export default function LoyaltyProgramPointsMeter(props: IProps) {
    const {tiers, customer} = props;
    const {t} = useTranslation();
    const [sortedTiers, setStortedTiers] = useState<Array<ITier>>([]);

    useEffect(() => {
        if (tiers) {
            const sortedTiers = tiers?.sort((a,b) => a.points_required - b.points_required);
            setStortedTiers(sortedTiers);
        }
    }, [tiers]);

    return (
        <div>
           <h1>{t("Your Progress")}</h1>
           <br /> 
           <Card title={`${customer?.points_balance} ${t("Points Balance")}`}>
                <Card.Section>
                    <div className="loyalty-program-rewards-meter">
                    {sortedTiers?.map((tier, index, allTiers) => {
                        const tierAchieved = customer?.points_balance >= tier?.points_required;
                        let currentTier = false;
                        if (allTiers[index - 1]) {
                            if (customer?.points_balance >= allTiers[index - 1]?.points_required && customer?.points_balance < tier?.points_required) {
                                currentTier = true;
                            }
                        }
                        return (
                            <React.Fragment key={index}>
                            <div className={classNames("loyalty-program-rewards-meter-icon", {"loyalty-program-rewards-meter-icon-current": currentTier, "loyalty-program-rewards-meter-icon-disabled": customer?.points_balance < tier?.points_required && !currentTier})}>
                                    <FontAwesomeIcon fixedWidth icon={tierAchieved ? faCheck : faCircle} style={{fontSize: !tierAchieved ? "8px" : undefined}}/>

                                    <div className="loyalty-program-rewards-meter-container">
                                    <p className="loyalty-program-rewards-meter-primary">{tier?.title} </p>
                                    <p className="loyalty-program-rewards-meter-secondary">{tier?.points_required} {t("points earned")}</p>
                                </div>
                                </div>
                               
                            {index !== allTiers?.length - 1 ? (
                                <div className={classNames("loyalty-program-rewards-meter-branch", {"loyalty-program-rewards-meter-branch-disabled":  (customer?.points_balance < tier?.points_required && !currentTier) || currentTier})}> </div>
                            ) : null}
                            </React.Fragment>
                        );
                    })}
                    </div>
                </Card.Section>
           </Card>
        </div>
    );
}   